import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import ContentPage from '../components/ContentPage';
import { faqContent } from '../content/faqContent';

function FAQArticle() {
  const { slug } = useParams();
  const content = faqContent[slug];

  if (!content) {
    return <Navigate to="/faq" replace />;
  }

  return (
    <ContentPage
      title={content.title}
      body={content.body}
      basePath="faq"
      backLabel="Back to FAQ"
    />
  );
}

export default FAQArticle;
